jQuery(document).ready(function($){
	console.log('Welcome to Larry Wright Music Theme!');
});